// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLocaleField(obj: any, locale: string, field: string): string {
  if (locale === "en") {
    const enField = `${field}En`;
    const enValue = obj[enField];
    if (typeof enValue === "string" && enValue.trim() !== "") {
      return enValue;
    }
  }
  const value = obj[field];
  return typeof value === "string" ? value : "";
}
